export const pageRoutes = {
    login: '/',
    dashboard: '/dashboard',
    lineOperator: "/line-operator",
    plantSettings: "/plant-settings",
    integrations: "/integrations",
    downtimeLog: "/downtime-log",
    lineSettings: "/line-settings",
    LineLevelBoard: "/line-level-board",
    lineBoard: "/line-board",
    AuditTrail: "/AuditTrail",
    LineCharttt: '/LineChart',
    LineCharttwo: '/LineCharttwo',
    oee: {
        homepage: "/oee/home",
        linePerformanceMonitor: '/oee/line-performance-monitor',
    }
}

export const pages = {
    0: 'Home - ProCheck',
    1: 'Dashboard - ProCheck',
    // 2: 'Plant Average View - ProCheck',
    3: 'Line Performance Monitor - ProCheck',
    4: 'Line Level Board - ProCheck',
    5: 'Line Board - ProCheck',
    // 7: 'Merge Dashboard - ProCheck',
    8: 'Line Operator - ProCheck',
    9: 'Downtime Logs - ProCheck',
    10: 'Line Settings - ProCheck',
    11: 'Plant Settings - ProCheck',
    12: 'Integrations - ProCheck',
    13: 'Audit Trails - ProCheck',
}



